import React, { ReactNode } from 'react'
import ImageForest from 'src/assets/img/auth-background.png'
interface AuthWrapperProps {
  children: ReactNode
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  return (
    <div className="flex h-screen w-full overflow-hidden">
      <div className="w-full overflow-y-auto bg-gray-900 p-10 lg:w-1/2">
        {/* my-auto centers short forms but still lets tall ones scroll from the top */}
        <div className="mx-auto my-auto flex min-h-full w-full max-w-md flex-col justify-center py-4 text-white">
          <div className="w-full space-y-6">{children}</div>
        </div>
      </div>
      <div className="relative hidden lg:block lg:w-1/2">
        <div className="absolute inset-0 p-10">
          <img src={ImageForest} alt="Authentication background" className="h-full w-full rounded-2xl object-cover" />
        </div>
      </div>
    </div>
  )
}

export default AuthWrapper
